import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { updateCategoryRule } from 'SpendControl/endpoints'
import type { UpdateCategoryRule } from 'SpendControl/endpoints/spend-control'

type UpdateCategoryRuleParams = { id: string } & UpdateCategoryRule

export const useUpdateCategoryRule = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({ id, ...body }: UpdateCategoryRuleParams) => updateCategoryRule(id, body),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
